<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-I">To my grandparents, Nathan and Ida</span></p>
<p class="DED"><span class="ePub-I">And to the workers</span></p>
<p class="DED"> </p>
<p class="DED"> </p>
<p class="FMEP"><span class="ePub-I">“I don’t know how it came to me, so much common sense.”</span></p>
<p class="FMEPC">—Nathan Handwerker</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?87181292